const CLIENT_INSTANCE_ID_KEY = 'gba.comms.clientInstanceId';

export const getCommsClientInstanceId = (
  randomUUID: () => string = () => crypto.randomUUID(),
) => {
  const existing = localStorage.getItem(CLIENT_INSTANCE_ID_KEY);
  if (existing) return existing;

  const clientInstanceId = randomUUID();
  localStorage.setItem(CLIENT_INSTANCE_ID_KEY, clientInstanceId);
  return clientInstanceId;
};
